<span
  class="notificationToast__input"
  [ngClass]="{'notificationToast__input--filled': isPromptFocused}">
  <input
    (input)="toast.value = $event.target.value; toast.eventEmitter.next('input')"
    autofocus
    class="notificationToast__input__field"
    type="text"
    [id]="toast.id"
    (focus)="isPromptFocused = true"
    (blur)="isPromptFocused = !!toast.value.length;">
  <label
    class="notificationToast__input__label"
    [for]="toast.id">
    <span class="notificationToast__input__labelContent">{{toast.config.placeholder | truncate}}</span>
  </label>
</span>
